// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.company-info_form[data-v-48f0e2c9] {\n  padding: 40px 60px 40px 20px\n}\n.footer[data-v-48f0e2c9] {\n  float: right;\n  margin-top: -30px;\n  margin-right: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
